module.exports = __webpack_public_path__ + "img/mfs-logo.6182a65a.png";